import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AgentAvatar } from "@/components/AgentAvatar";
import { Agent } from "@/types/agent";
import { useAppState } from "@/store/useApp";
import { useNavigate } from "react-router";
import AppHeader from "@/components/AppHeader";

export const Agents = () => {
  const agents = useAppState((state) => state.agents);
  const navigate = useNavigate();

  const handleCreateAgent = () => {
    navigate("/agents/new");
  };

  const handleEditAgent = (agentId: string) => {
    navigate(`/agents/${agentId}`);
  };

  if (!agents) {
    return null;
  }

  return (
    <div className="flex flex-col max-w-5xl h-full pt-20 px-4 mx-auto w-full min-h-0">
      <div className="flex justify-between items-center mb-6 shrink-0">
        <AppHeader primary="Agents" secondary="for assessment" />
      </div>

      <div className="flex-1 overflow-y-auto min-h-0 pr-1 pb-10">
        <div className="flex flex-col gap-4">
          {/* Agent cards */}
          {agents.map((agent) => (
            <Card key={agent.id} className="flex p-4">
              <div className="flex items-center w-full">
                <AgentAvatar agent={agent} size="lg" className="mr-4 shrink-0" />

                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold">{agent.name}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-1">
                    {agent.description}
                  </p>
                </div>

                <div className="ml-4 shrink-0">
                  <Button
                    size="sm"
                    onClick={() => handleEditAgent(agent.id)}
                  >
                    View
                  </Button>
                </div>
              </div>
            </Card>
          ))}

          {/* New agent placeholder */}
          <Card
            className="flex p-4 border-dashed border-2 bg-transparent"
          >
            <div className="flex items-center w-full">
              <AgentAvatar
                agent={
                  {
                    name: "New agent",
                    avatar: "user",
                    id: "",
                    description: "",
                    instructions: "",
                  } as Agent
                }
                size="lg"
                className="mr-4 shrink-0"
              />

              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold">New agent</h3>
                <p className="text-sm text-muted-foreground">
                  Create new agent from scratch.
                </p>
              </div>

              <div className="ml-4 shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCreateAgent();
                  }}
                >
                  Create
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
